interface HeroProps {
  onOpenModal: () => void;
}

export default function Hero({ onOpenModal }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/5dffa4c0f117da98b3865f4f84160bdf.jpg"
          alt="Industrial welding background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/042557a158b596551b7acb61d66aac00/ae9ed59fe1896a8f4d9b0d1f20cc888c.png"
            alt="Mobile Welding Repair and Fabrication"
            className="h-24 w-auto"
          />
        </div>

        {/* Main Headline */}
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Precision Welding On-Site:<br />
          <span className="text-orange-500">We Bring the Shop to You</span>
        </h1>

        {/* Sub-headline */}
        <p className="text-xl md:text-2xl text-gray-200 mb-4 max-w-3xl mx-auto leading-relaxed">
          Emergency Repairs & Custom Fabrication for Heavy Equipment, Structural Work, and Industrial Applications
        </p>
        <p className="text-lg text-gray-300 mb-12">
          <i className="ri-map-pin-line mr-1 text-orange-500"></i> Serving from <strong>Madison Lake</strong> & <strong>Eagan, MN</strong>
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={onOpenModal}
            className="whitespace-nowrap bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg px-10 py-5 rounded-lg transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105 cursor-pointer"
          >
            Get Free Estimate
          </button>
          <a
            href="tel:+15073980496"
            className="whitespace-nowrap bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white font-bold text-lg px-10 py-5 rounded-lg transition-all duration-300 cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Now: Mon-Sat
          </a>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-shield-check-line text-2xl text-orange-500"></i>
            </div>
            <span className="text-sm font-semibold">AWS Certified</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-time-line text-2xl text-orange-500"></i>
            </div>
            <span className="text-sm font-semibold">Emergency Service Available</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-checkbox-circle-line text-2xl text-orange-500"></i>
            </div>
            <span className="text-sm font-semibold">Fully Insured</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-3xl text-white"></i>
        </div>
      </div>
    </section>
  );
}
